import AnchorDropdown from '@components/AnchorDropdown'
import Button from '@components/UI/Button'
import Container from '@components/UI/Container'
import css from '@utils/css'
import updatesTraqqImage from '@images/updates-traqq.png'

import { Navigation } from "@layouts/NavigationV2"

import PropTypes from 'prop-types'
import React, { useEffect, useState } from 'react'

import useUtmTags from '@hooks/useUtmTags'

const Updates = ({ post: { content, dates } }) => {

    const anchorData = dates.reduce((res, date) => {
        const year = res.find(({ title }) => title === `Release notes ${ date.year }`)

        if (year) {
            year.data = [
                ...year.data,
                {
                    title: date.month,
                    href: `#${ date.month } ${ date.year }`
                }
            ]
        } else {
            res = [
                ...res,
                {
                    title: `Release notes ${ date.year }`,
                    data: [
                        {
                            title: date.month,
                            href: `#${ date.month } ${ date.year }`
                        }
                    ]
                }
            ]
        }

        return res
    }, [])

    return (
        <>
            <Navigation
                staticTheme="light"
                actionTheme="light"
            />

            <Header/>

            <Container>
                <div
                    className={ css(`
                    flex justify-between gap-x-18 mb-12 1024:mb-20 editor-post relative
                    before:480:(content-[''] w-px bg-neutral-400 top-6 absolute h-full -left-[1px])
                    `) }
                >
                    <div
                        className={ css('flex flex-col gap-y-12 480:gap-y-14 1024:(gap-y-18)') }
                        dangerouslySetInnerHTML={ { __html: content } }
                    />

                    <AnchorDropdown data={ anchorData }/>
                </div>
            </Container>
        </>
    )
}

Updates.propTypes = {
    post: PropTypes.object.isRequired
}

const Header = () => {
    const [isProfitCountry, setIsProfitCountry] = useState(false)
    const feedbackUrl = useUtmTags(`${ process.env.NEXT_PUBLIC_APP_TRAQQ_URL }/feedback`, {utm_medium: 'top_banner'})

    useEffect(() => {
        (async () => {
            const countryUrl = process.env.NEXT_PUBLIC_APP_URL === 'https://test.traqq.com'
                ? '/api/test-support-country'
                : `${ process.env.NEXT_PUBLIC_APP_URL }/api/v1/support/country`
            const response = await fetch(countryUrl)

            if (!response.ok) return

            const countryData = await response.json()
            setIsProfitCountry(countryData && countryData.userCountryInfo.code && countryData.profitCountries.includes(countryData.userCountryInfo.code))
        })()
    }, [])

    return (
        <div className='bg-neutral-900'>
            <div
                style={ { backgroundImage: `url("${ updatesTraqqImage.src }")` } }
                className={ css(`
                    flex w-full h-[480px] bg-no-repeat bg-neutral-900 bg-[size:569px] mb-8 m-auto container
                    [background-position-x:center] [background-position-y:-45px] justify-center
                    480:(h-[588px] bg-[size:718px] [background-position-y:-51px])
                    768:(justify-start h-auto py-16 pl-10 bg-[size:797px])
                    768:([background-position-x:190px] [background-position-y:-62px])
                    1024:(py-18 mb-12 bg-[size:950px] [background-position-x:308px] [background-position-y:-74px])
                    1280:(py-20 pl-5 bg-[size:988px] [background-position-x:481px] [background-position-y:-77px])
                    `
                ) }
            >
                <div className={ css(
                    'self-end mb-12 flex flex-col items-center mx-5 gap-y-8',
                    '480:(mx-10 mb-16)',
                    '768:(self-auto items-start m-0)',
                    isProfitCountry ? null : 'py-[45px]'
                ) }
                >
                    <h1 className={ css(
                        'text-white text-center h1',
                        '768:text-left'
                    ) }>
                        What&apos;s new?
                        <br/>
                        Check out the latest
                        <br/>
                        product updates
                    </h1>
                    { isProfitCountry &&
                        <Button
                            tag='a'
                            type='link'
                            href={ feedbackUrl }
                            size='lg'
                            variant={ 'primary' }
                        >
                            Suggest a Feature
                        </Button>
                    }
                </div>
            </div>
        </div>
    )
}

Header.propTypes = {
    isProfitCountry: PropTypes.bool
}


export default Updates
